var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row mat24" }, [
          _c("div", { staticClass: "col-lg-12 dashboard" }, [
            _c("div", { staticClass: "dashboard-wrapper" }, [
              _vm.competitionSetting.canQR === false
                ? _c(
                    "div",
                    { staticClass: "insurance" },
                    [
                      _vm._m(0),
                      _vm._m(1),
                      _c(
                        "base-button",
                        {
                          attrs: { btn1: "" },
                          on: {
                            click: function ($event) {
                              return _vm.save("on")
                            },
                          },
                        },
                        [_vm._v("Włącz Kody QR")]
                      ),
                    ],
                    1
                  )
                : _vm.competitionSetting.canQR
                ? _c(
                    "div",
                    { staticClass: "insurance" },
                    [
                      _vm._m(2),
                      _c(
                        "base-button",
                        {
                          attrs: { btn2: "" },
                          on: {
                            click: function ($event) {
                              return _vm.save("off")
                            },
                          },
                        },
                        [_vm._v("Wyłącz Kody QR")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm.competitionSetting.canQR
            ? _c("div", { staticClass: "col-12 mt-4" }, [
                _c("div", { staticClass: "add-point-wrapper" }, [
                  _c("h3", [_vm._v("Dodaj nowy czytnik QR")]),
                  _c("div", { staticClass: "row align-items-center mat24" }, [
                    _c("div", { staticClass: "col-lg-6 col-12" }, [
                      _c("div", { staticClass: "input-field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newPointIdentifier,
                              expression: "newPointIdentifier",
                            },
                          ],
                          staticClass: "input-field__input",
                          attrs: {
                            type: "text",
                            placeholder: "Nazwa punktu (np. brama-wschodnia)",
                          },
                          domProps: { value: _vm.newPointIdentifier },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.newPointIdentifier = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-12 mt-2 mt-lg-0" },
                      [
                        _c(
                          "base-button",
                          {
                            attrs: {
                              btn1: "",
                              disabled: !_vm.newPointIdentifier,
                            },
                            on: { click: _vm.createPickUpPoint },
                          },
                          [_vm._v(" Generuj nowy czytnik ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.competitionSetting.canQR && _vm.pickUpPoints.length > 0
            ? _c(
                "div",
                { staticClass: "col-12 mt-4" },
                _vm._l(_vm.pickUpPoints, function (point) {
                  return _c(
                    "div",
                    { key: point.id, staticClass: "point-card mat24" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-lg-8 col-12 d-flex flex-column" },
                          [
                            _c("div", { staticClass: "point-header" }, [
                              _c("h3", [
                                _vm._v(
                                  "Punkt: " +
                                    _vm._s(
                                      point.identifier === "1"
                                        ? "Główny"
                                        : point.identifier
                                    )
                                ),
                              ]),
                              _c("small", { staticClass: "text-muted small" }, [
                                _vm._v("Utworzono: " + _vm._s(point.createdAt)),
                              ]),
                            ]),
                            _c("div", { staticClass: "mat16" }, [
                              _vm._v("Link do czytnika:"),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mat8 border-box--gray checkpoint__link align-items-center justify-content-space-between mt-2",
                              },
                              [
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(_vm.getLink(point))),
                                ]),
                                _c(
                                  "base-button",
                                  {
                                    staticClass:
                                      "mt-4 mt-lg-0 ml-lg-3 flex-shrink-0",
                                    attrs: { btn9: "", icon: "far fa-link" },
                                    on: {
                                      click: function ($event) {
                                        _vm.copyLink(_vm.getLink(point))
                                      },
                                    },
                                  },
                                  [_vm._v(" Kopiuj ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-4 col-12 mt-4 mt-lg-0 text-center",
                          },
                          [
                            _c("div", { staticClass: "qr-wrapper" }, [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v("Kod QR do skanera"),
                              ]),
                              _vm.qrImages[point.identifier]
                                ? _c("div", { staticClass: "qr-image-box" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.qrImages[point.identifier],
                                        alt: "QR Code",
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "qr-loading" }, [
                                    _c("i", {
                                      staticClass: "fas fa-spinner fa-spin",
                                    }),
                                    _vm._v(" Generowanie... "),
                                  ]),
                              _c("div", { staticClass: "player-count mat8" }, [
                                _c("span", { staticClass: "count-badge" }, [
                                  _vm._v(" Zeskanowano osób: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(point.playerCount)),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "insurance-status" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/close-circle.svg"), alt: "" },
      }),
      _c("h2", [_vm._v("Kody QR nieaktywne")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "insurance-content" }, [
      _c("p", [
        _c("b", [
          _vm._v(
            "Uczestnicy będą automatycznie dostawać kody QR w mailu z rejestracją."
          ),
        ]),
      ]),
      _c("p", [
        _vm._v("Dzięki temu odbierze pakiet startowy w prostszy sposób."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "insurance-status active mb-4" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/checkmark-circle.svg"),
          alt: "",
        },
      }),
      _c("h2", { staticClass: "text-green" }, [_vm._v("Kody QR aktywne")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }